export const StackWidgetSize = {
	LARGE: 'large',
	MEDIUM: 'medium',
	SMALL: 'small',
	TINY: 'tiny',
};